import router from "../router";
import store from "../store";

export default {
  async get(endpoint, params) {
    let url = endpoint;
    if (params) {
      const queryParams = new URLSearchParams(params).toString();
      url += `?${queryParams}`;
    }
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 403) {
      const data = await response.json();
      if (data.error === "Expired Token") {
        await store.dispatch("logOut");
        router.push({ name: "Login" });
      }
    }
    return await response.json();
  },
  async post(endpoint, data) {
    const response = await fetch(endpoint, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (response.status === 403) {
      const data = await response.json();
      if (data.error === "Expired Token") {
        await store.dispatch("logOut");
        router.push({ name: "Login" });
      }
    }
    return await response.json();
  },
  async put(endpoint, data) {
    const response = await fetch(endpoint, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (response.status === 403) {
      const data = await response.json();
      if (data.error === "Expired Token") {
        await store.dispatch("logOut");
        router.push({ name: "Login" });
      }
    }
    return await response.json();
  },
  async patch(endpoint, data) {
    const response = await fetch(endpoint, {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (response.status === 403) {
      const data = await response.json();
      if (data.error === "Expired Token") {
        await store.dispatch("logOut");
        router.push({ name: "Login" });
      }
    }
    return await response.json();
  },
  async delete(endpoint) {
    const response = await fetch(endpoint, {
      method: "DELETE",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 403) {
      const data = await response.json();
      if (data.error === "Expired Token") {
        await store.dispatch("logOut");
        router.push({ name: "Login" });
      }
    }
    return await response.json();
  },
};


